import {Configuration, DefaultApi, Todo} from "./api/";
import {TodoStore} from "./TodoStore";

export class RestTodoStore implements TodoStore {
    private readonly defaultApi: DefaultApi

    constructor(apiBaseUrl: string) {
        this.defaultApi = new DefaultApi(
            new Configuration({
                basePath: apiBaseUrl
            })
        );
    }

    async getTodos(user_id: number): Promise<Todo[]> {

        try {
            return this.defaultApi.getFetchTodos({
                userId: user_id + ""
            });
        } catch (error) {
            console.error("Error occurred while fetching todos:", error);
            return [];
        }
    }

    async addTodo(todoDescription: string) {
        try {
            return await this.defaultApi.postAddtodo({
                todoInput: {
                    isDone: false,
                    content: todoDescription
                }
            });
        } catch (error) {
            console.error("Error occurred while adding todo:", error);
            throw error;
        }
    }

    async updateTodo(todoId: number, content?: string, isDone?: boolean) {
        try {
            return await this.defaultApi.patchUpdateTodo({
                id: todoId,
                updateTodoParameters: {isDone, content}
            })
        } catch (error) {
            console.error("Error occurred while modifying todo:", error);
            throw error;
        }
    }

    async remove(todoId: number) {
        try {
            const response = await this.defaultApi.deleteRemovetodo({
                id: todoId + ""
            })
        } catch (error) {
            console.error("Error occurred while modifying todo:", error);
            throw error;
        }
    }

    async remove_all() {
        try {
            const response = await this.defaultApi.deleteRemoveall();
        } catch (error) {
            console.error("Error occurred while modifying todos:", error);
            throw error;
        }
    }
}
